module.exports = __webpack_public_path__ + "static/media/garden.4.778bd5b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/rooms/standard-garden/images/garden.4.jpg
// module id = 674
// module chunks = 0